// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PublicEventParticipateDoc_document__xj0dE {
  box-shadow: 0px 8px 32px 0px rgba(0, 0, 0, 0.0784313725);
  padding: 24px 24px 30px;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
}
.PublicEventParticipateDoc_document-title__8PFqf {
  font-size: 20px;
  font-weight: 600;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.PublicEventParticipateDoc_document-title__wrapper__EV9R5 {
  display: flex;
  margin-bottom: 16px;
}
.PublicEventParticipateDoc_document-title__arrow__s\\+YVA {
  display: flex;
  align-items: center;
  margin-left: 15px;
}
.PublicEventParticipateDoc_document-title__arrow__s\\+YVA svg {
  transform: rotate(-90deg) scale(1.4);
}
.PublicEventParticipateDoc_document-status__iF0Z4 {
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  border-radius: 4px;
  padding: 0 4px;
}
.PublicEventParticipateDoc_document-status__text__xqQot {
  font-size: 12px;
  color: #7d838a;
  margin-bottom: 15px;
}
.PublicEventParticipateDoc_document-status__approved__HK-Ou {
  background: #97dccc;
}
.PublicEventParticipateDoc_document-status__auto_check__r4p-Y {
  background: #d6e9f9;
}
.PublicEventParticipateDoc_document-status__new__jGdyH {
  background: #ffe5cd;
}
.PublicEventParticipateDoc_document-status__published__cN3un {
  background: #def5e3;
}
.PublicEventParticipateDoc_document-status__published_for_member__vVXb8 {
  background: #f0def5;
}
.PublicEventParticipateDoc_document-status__rejected__I62Wf {
  background: #f6a7ac;
}
.PublicEventParticipateDoc_document-status__review__Tfd2Y {
  background: #d6e9f9;
}
.PublicEventParticipateDoc_document-status__rework__nX2uT {
  background: #fadddd;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/publicEventsCatalog/PublicEventParticipate/PublicEventParticipateDoc/PublicEventParticipateDoc.module.scss"],"names":[],"mappings":"AAAA;EACE,wDAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AACF;AACE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AACJ;AACI;EACE,aAAA;EACA,mBAAA;AACN;AAEI;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;AAAN;AACM;EACE,oCAAA;AACR;AAIE;EACE,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;AAFJ;AAII;EACE,eAAA;EACA,cAAA;EACA,mBAAA;AAFN;AAKI;EACE,mBAAA;AAHN;AAMI;EACE,mBAAA;AAJN;AAMI;EACE,mBAAA;AAJN;AAMI;EACE,mBAAA;AAJN;AAMI;EACE,mBAAA;AAJN;AAMI;EACE,mBAAA;AAJN;AAMI;EACE,mBAAA;AAJN;AAMI;EACE,mBAAA;AAJN","sourcesContent":[".document {\n  box-shadow: 0px 8px 32px 0px #00000014;\n  padding: 24px 24px 30px;\n  border-radius: 12px;\n  overflow: hidden;\n  cursor: pointer;\n\n  &-title {\n    font-size: 20px;\n    font-weight: 600;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n\n    &__wrapper {\n      display: flex;\n      margin-bottom: 16px;\n    }\n\n    &__arrow {\n      display: flex;\n      align-items: center;\n      margin-left: 15px;\n      svg {\n        transform: rotate(-90deg) scale(1.4);\n      }\n    }\n  }\n\n  &-status {\n    font-size: 12px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: fit-content;\n    border-radius: 4px;\n    padding: 0 4px;\n\n    &__text {\n      font-size: 12px;\n      color: #7d838a;\n      margin-bottom: 15px;\n    }\n\n    &__approved {\n      background: #97dccc;\n    }\n\n    &__auto_check {\n      background: #d6e9f9;\n    }\n    &__new {\n      background: #ffe5cd;\n    }\n    &__published {\n      background: #def5e3;\n    }\n    &__published_for_member {\n      background: #f0def5;\n    }\n    &__rejected {\n      background: #f6a7ac;\n    }\n    &__review {\n      background: #d6e9f9;\n    }\n    &__rework {\n      background: #fadddd;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"document": `PublicEventParticipateDoc_document__xj0dE`,
	"document-title": `PublicEventParticipateDoc_document-title__8PFqf`,
	"document-title__wrapper": `PublicEventParticipateDoc_document-title__wrapper__EV9R5`,
	"document-title__arrow": `PublicEventParticipateDoc_document-title__arrow__s+YVA`,
	"document-status": `PublicEventParticipateDoc_document-status__iF0Z4`,
	"document-status__text": `PublicEventParticipateDoc_document-status__text__xqQot`,
	"document-status__approved": `PublicEventParticipateDoc_document-status__approved__HK-Ou`,
	"document-status__auto_check": `PublicEventParticipateDoc_document-status__auto_check__r4p-Y`,
	"document-status__new": `PublicEventParticipateDoc_document-status__new__jGdyH`,
	"document-status__published": `PublicEventParticipateDoc_document-status__published__cN3un`,
	"document-status__published_for_member": `PublicEventParticipateDoc_document-status__published_for_member__vVXb8`,
	"document-status__rejected": `PublicEventParticipateDoc_document-status__rejected__I62Wf`,
	"document-status__review": `PublicEventParticipateDoc_document-status__review__Tfd2Y`,
	"document-status__rework": `PublicEventParticipateDoc_document-status__rework__nX2uT`
};
export default ___CSS_LOADER_EXPORT___;
